import { render, staticRenderFns } from "./InputPermissionForm.vue?vue&type=template&id=531a6098"
import script from "./InputPermissionForm.vue?vue&type=script&lang=js"
export * from "./InputPermissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports